(function () {
  "use strict";

  /* ── Accordion ── */
  function initAccordion(section) {
    section.querySelectorAll("[data-fsq-item]").forEach(function (item) {
      var btn    = item.querySelector("[data-fsq-btn]");
      var answer = item.querySelector(".fsq-answer");
      if (!btn || !answer) return;

      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("is-open");

        /* Close all siblings */
        var list = item.closest("[data-fsq-list]");
        if (list) {
          list.querySelectorAll("[data-fsq-item].is-open").forEach(function (sibling) {
            if (sibling === item) return;
            sibling.classList.remove("is-open");
            var sibBtn = sibling.querySelector("[data-fsq-btn]");
            var sibAnswer = sibling.querySelector(".fsq-answer");
            if (sibBtn) sibBtn.setAttribute("aria-expanded", "false");
            if (sibAnswer) { sibAnswer.style.maxHeight = "0"; }
          });
        }

        if (isOpen) {
          /* Close this */
          item.classList.remove("is-open");
          btn.setAttribute("aria-expanded", "false");
          answer.style.maxHeight = "0";
        } else {
          /* Open this */
          item.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
          answer.removeAttribute("hidden");
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  }

  /* ── Reveal ── */
  function initReveal(section) {
    var items   = section.querySelectorAll(".fsq-r");
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduced) { items.forEach(function (el) { el.classList.add("on"); }); return; }

    section.setAttribute("data-fsq-js", "true");

    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) { el.classList.add("on"); }); return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("on");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -32px 0px" });

    items.forEach(function (el) { observer.observe(el); });
  }

  function init(root) {
    root.querySelectorAll("[data-fsq-section]:not([data-fsq-ready])").forEach(function (section) {
      section.setAttribute("data-fsq-ready", "true");
      initAccordion(section);
      initReveal(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
